import { memo } from 'react';
import { useTranslations } from 'next-intl';
function SpecialQtyCart({ quantity, setQuantity, availableQty }) {
  const t = useTranslations('common');

  const handleIncreaseQuantity = () => {
    setQuantity((prev) => {
      const qty = prev + 1;
      return qty;
    });
  };

  const handleDecreaseQuantity = () =>
    setQuantity((prev) => Math.max(1, prev - 1));

  return (
    <div className='flex items-center gap-8 max-sm:fixed max-sm:start-0 max-sm:bottom-20 max-sm:z-100 max-sm:w-full max-sm:justify-between max-sm:bg-white max-sm:px-3 max-sm:pt-4 max-sm:pb-2.5 sm:mt-3 lg:!my-6'>
      <p className='font-semibold max-sm:hidden'>{t('quantity_key')}:</p>
      <div className='flex items-center space-x-4 max-sm:space-x-1'>
        <button
          className='border-border flex cursor-pointer items-center justify-center rounded-md border px-3 py-1 transition-all hover:bg-gray-200 disabled:cursor-not-allowed max-sm:size-7.5'
          onClick={handleDecreaseQuantity}
          disabled={quantity === 1}
        >
          -
        </button>
        <button className='border-border flex items-center justify-center rounded-md border px-3 py-1 max-sm:size-7.5'>
          {quantity}
        </button>
        <button
          disabled={quantity == availableQty}
          className='border-border flex cursor-pointer items-center justify-center rounded-md border px-3 py-1 transition-all hover:bg-gray-200 disabled:cursor-not-allowed max-sm:size-7.5'
          onClick={handleIncreaseQuantity}
        >
          +
        </button>
      </div>
    </div>
  );
}

export default memo(SpecialQtyCart);
